import { render, staticRenderFns } from "./InformationWarning.vue?vue&type=template&id=4c358910&"
import script from "./InformationWarning.vue?vue&type=script&lang=js&"
export * from "./InformationWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports